import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../componentes/button/button";
import { useNotificacoes } from "../../hooks/notificacoes/useNotificacoes";
import { infoNotificacao } from "../../utils/notificacoes/tipoNotificacao";
import { tempoDecorrido, formatarDataHora } from "../../utils/solicitacoes/formatters";
import { processoInfo, etapaLabel } from "../../utils/solicitacoes/processoRegistry";

const ABAS = [
    { chave: "todas", label: "Todas", lida: undefined },
    { chave: "naoLidas", label: "Não lidas", lida: false },
    { chave: "lidas", label: "Lidas", lida: true },
];

export default function NotificacoesTodas() {
    const navigate = useNavigate();
    const [aba, setAba] = useState("todas");

    const filtroAtivo = ABAS.find(a => a.chave === aba);
    const { notificacoes, loading, marcarComoLida, marcarTodasComoLidas, recarregar } = useNotificacoes(
        filtroAtivo.lida !== undefined ? { lida: filtroAtivo.lida } : {}
    );

    useEffect(() => {
        document.title = "MyDash | Todas as Notificações";
    }, []);

    async function abrirNotificacao(n) {
        if (!n.lida) await marcarComoLida(n.id);
        if (n.solicitacaoId) navigate(`/solicitacoes/${n.solicitacaoId}`);
    }

    async function handleMarcarTodas() {
        await marcarTodasComoLidas();
        recarregar();
    }

    const temNaoLida = notificacoes.some(n => !n.lida);

    return (
        <main className="px-4 py-6">
            <div className="max-w-4xl mx-auto flex flex-col gap-4">
                <div className="flex items-center justify-between flex-wrap gap-3">
                    <h1 className="font-display text-2xl font-bold text-foreground">Todas as Notificações</h1>
                    {temNaoLida && (
                        <Button variant="outline" label="Marcar todas como lidas" iconLeft="fa fa-check-double" onClick={handleMarcarTodas} />
                    )}
                </div>

                <div className="flex items-center gap-2">
                    {ABAS.map(a => (
                        <button
                            key={a.chave}
                            onClick={() => setAba(a.chave)}
                            className={`px-3 py-1.5 text-sm font-medium rounded-full border transition-colors ${
                                aba === a.chave
                                    ? "bg-primary text-primary-foreground border-primary"
                                    : "bg-card text-muted-foreground border-border hover:bg-muted"
                            }`}
                        >
                            {a.label}
                        </button>
                    ))}
                </div>

                <div className="bg-card border border-border rounded-lg shadow-card divide-y divide-border">
                    {loading ? (
                        <p className="text-sm text-muted-foreground text-center py-10">Carregando...</p>
                    ) : notificacoes.length === 0 ? (
                        <p className="text-sm text-muted-foreground text-center py-10">Nenhuma notificação encontrada.</p>
                    ) : (
                        notificacoes.map(n => {
                            const info = infoNotificacao(n.tipo);
                            const processoLabel = n.tipoProcesso ? (processoInfo(n.tipoProcesso)?.label || n.tipoProcesso) : null;
                            const etapaTxt = n.etapaCodigo ? (etapaLabel(n.tipoProcesso, n.etapaCodigo) || n.etapaCodigo) : null;
                            const corDot = info.cor === "verde" ? "bg-success" : info.cor === "vermelho" ? "bg-destructive" : "bg-primary";

                            return (
                                <button
                                    key={n.id}
                                    onClick={() => abrirNotificacao(n)}
                                    className={`w-full flex items-start gap-3 p-4 text-left hover:bg-muted/60 transition-colors ${!n.lida ? "bg-primary/5" : ""}`}
                                >
                                    <span className={`mt-1.5 w-2.5 h-2.5 rounded-full shrink-0 ${corDot}`} />
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-2 flex-wrap">
                                            <span className="text-sm font-semibold text-foreground">{n.titulo}</span>
                                            {!n.lida && (
                                                <span className="text-[10px] font-semibold uppercase tracking-wide bg-primary/10 text-primary rounded-full px-2 py-0.5">
                                                    Não lida
                                                </span>
                                            )}
                                        </div>
                                        <p className="text-sm text-muted-foreground mt-0.5">{n.mensagem}</p>
                                        <div className="flex items-center gap-2 flex-wrap mt-1.5 text-xs text-muted-foreground">
                                            {n.solicitacaoNumero && <span>Solicitação {n.solicitacaoNumero}</span>}
                                            {etapaTxt && <span>· {etapaTxt}</span>}
                                            {processoLabel && <span>· {processoLabel}</span>}
                                            <span className="ml-auto" title={formatarDataHora(n.dataHora)}>{tempoDecorrido(n.dataHora)}</span>
                                        </div>
                                    </div>
                                </button>
                            );
                        })
                    )}
                </div>
            </div>
        </main>
    );
}
